export const defaultInputProps = {
    addonType: 'append',
    className: 'form-control',
    group: true,
    groupClassName: ''
}
